module.exports = __webpack_public_path__ + "static/media/icon_yewuzhuanjia.5a4aa6c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/icon_yewuzhuanjia.svg
// module id = 130
// module chunks = 0